<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Payment Terms & Conditions</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>AUTHORIZATION</label><br/>
          <span>
            By checking the "I accept the Terms and Conditions" checkbox below I authorize my bank to debit my specified account for the amount of my payment. This is a one-time payment which will occur on the next business day or as soon as practical thereafter.
            <br>
            If my payment cannot be completed for any reason, including insufficient funds or error in the information which I submitted, I will retain the same liability, which is my sole responsibility, for payment as though I had not attempted to make the payment.
            I also understand that additional fees and penalties may be collected to the extent of applicable law.
          </span>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>RECEIPT</label><br/>
          <span>A receipt can be printed after payment is accepted which may serve as evidence of payment. If an email address is provided during the payment process, a receipt will be emailed to you after the payment is processed.</span>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>CONTACT</label><br/>
          <span>If for any reason you wish to make a change to the payment after submission, please contact {{ merchantName }} for assistance at {{ contactNumber }}.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
  </div>

</div>
